import { z } from 'zod';
import { AiDateSchema } from './AiDateSchema';

export const AiCareDocumentWorkDetailsSchema = z.object({
  jobTitle: z.string().nullish(),
  dateSignedOff: AiDateSchema,
  workPattern: z.string().nullish(),
  hideHopingToReturnToWorkIn: z.boolean().nullish(),
  hopingToReturnToWorkIn: z.string().nullish(),
});

export type AiCareDocumentWorkDetails = z.infer<
  typeof AiCareDocumentWorkDetailsSchema
>;
